export default __webpack_public_path__ + "static/media/SportKLS_Posterior.15ec7251.webp";